import Application from "airports/p11v5-nsru-api/Application";
import ResetCard1Blank from "project-components/cards/ResetCard1Blank";
import React from "react";
import {
    Container,
    Row,
    Col,
} from "reactstrap";
import ListGroup from "reactstrap/lib/ListGroup";
import Array from "../../../../../libraries/Array";
import AppIcon from "../../../../../project-components/parts/AppIcon";
import WidgetTemplate1 from "../../../../widgets/WidgetTemplate1";

class ApplicationSection extends React.Component
{

    constructor(props) {
        super(props);

        this.localStorageKey = 'person-apps-' + this.props.groupId;

        let apps = []
        if(localStorage.getItem(this.localStorageKey))
        {
            apps = JSON.parse(localStorage.getItem(this.localStorageKey))
        }

        this.style = {
            colXs: this.props.styleColXs ?? 4,
            colMd: this.props.styleColMd ?? 3
        }

        this.state = {
            apps: apps
        }

    }

    async componentDidMount() {
        const appAPI = new Application();
        let res = await appAPI.browseByGroup(this.props.groupId);
        let ids = Array.pluck(res, 'id');
        this.setState({
            apps: ids
        })
    }

    render() {
      return (
        <>
          <ResetCard1Blank
            title="ระบบสารสนเทศ"
            body={
              <>
                <ListGroup>
                  {this.state.apps.map((appId, i) => {
                    //Return the element. Also pass key
                    return (
                      <>
                        <AppIcon
                          id={appId}
                          withCircle="1"
                        />
                      </>
                    )
                  })}
                </ListGroup>
              </>
            }
          />
        </>
      );
    }

}

export default ApplicationSection;
